import { Followers, PlayCircle } from '@sparemin/blockhead';
import Tabs from 'components/Tabs';
import useMobileBreakpoint from 'hooks/useMobileBreakpoint';
import React from 'react';
import PlaysDashboard from './PlaysDashboard';
import PodcastEpisodesTable from './PlaysDashboard/PodcastMetricsByEpisodeTable';
import PodcastFollowers from './PodcastFollowers';

type PodcastEpisodesViewProps = {};

const PodcastEpisodesView: React.FC<PodcastEpisodesViewProps> = () => {
  const isMobile = useMobileBreakpoint('md');

  return (
    <Tabs
      content={[
        {
          label: 'Plays',
          content: isMobile ? <PodcastEpisodesTable /> : <PlaysDashboard />,
          icon: <PlayCircle />,
        },
        {
          label: 'followers',
          content: <PodcastFollowers />,
          icon: <Followers />,
        },
      ]}
    />
  );
};
export default PodcastEpisodesView;
